import styled from '@emotion/styled';
import { imagePath } from 'presentations/assets';
import {
  defaultHeight,
  defaultWidth,
} from 'domains/models/event_type/coverImage';

interface Props {
  coverImage?: string | null;
}

export default function Component(props: Props) {
  if (!props.coverImage) return null;
  return (
    <Container aspectRatio={defaultWidth / defaultHeight}>
      <Cover>
        <CoverImage
          role="img"
          aria-busy={true}
          style={{
            backgroundImage: `url(${imagePath(props.coverImage, {
              width: defaultWidth,
              height: defaultHeight,
              fit: 'crop',
              dpr: 2,
            })})`,
          }}
        />
      </Cover>
    </Container>
  );
}

const Container = styled.div<{ aspectRatio: number }>`
  position: relative;
  width: 100%;
  aspect-ratio: ${(props) => props.aspectRatio};
  overflow: hidden;
`;
const Cover = styled.div`
  position: absolute;
  overflow: hidden;
  top: 0px !important;
  left: 0px !important;
  bottom: 0px !important;
  right: 0px !important;
`;
const CoverImage = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat !important;
  vertical-align: bottom !important;
`;
